import React from 'react';
import { useSelector } from 'react-redux';
import { getElementAccessType } from '../../../selectors/navigation';
import { partnerShape } from '../types';
import BasePartnerAppSitesSummary from './BasePartnerAppSitesSummary';
import UserConfigurationAppSitesSummary, { USER_CONFIGURATION_PARTNER_NAMES } from './UserConfigurationAppSitesSummary';
import { SECTION_ACCESS_TYPES } from '../../../utils/consts';

// TODO new shelf will use the partner.accountsSupport, remove the const later
const hasUserConfiguration = partner =>
    USER_CONFIGURATION_PARTNER_NAMES.includes(partner.name) || partner.accountsSupport;

const PartnerAppSitesSummaryFactory = props => {
    const accessType = useSelector(getElementAccessType('new_partner_config'));
    const { partner } = props;
    const summaryProps = {
        ...props,
        canAddAppSite: accessType === SECTION_ACCESS_TYPES.EDIT,
    };

    if (hasUserConfiguration(partner)) {
        return <UserConfigurationAppSitesSummary {...summaryProps} />;
    } else {
        return <BasePartnerAppSitesSummary {...summaryProps} />;
    }
};

PartnerAppSitesSummaryFactory.propTypes = {
    partner: partnerShape.isRequired,
};

export default PartnerAppSitesSummaryFactory;
